"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeStringName = sanitizeStringName;
exports.sanitizeDashedString = sanitizeDashedString;
exports.sanitizeHtmlString = sanitizeHtmlString;
exports.sanitizeStringLength = sanitizeStringLength;
exports.sanitizeLeadingTrailingCharacters = sanitizeLeadingTrailingCharacters;
function sanitizeStringName(str) {
    return str
        .trim()
        .replace(/[^a-zA-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '') // remove leading or trailing underscores
        .toLowerCase();
}
function sanitizeDashedString(str) {
    return str.trim().replace(/-/g, '_');
}
function sanitizeHtmlString(str) {
    return str.trim().replace(/<[^>]*>/g, '');
}
function sanitizeStringLength(str, maxLength) {
    const ELLIPSIS_STR = '...';
    return str.length > maxLength ? `${str.slice(0, maxLength - ELLIPSIS_STR.length)}${ELLIPSIS_STR}` : str;
}
function sanitizeLeadingTrailingCharacters(str, characters) {
    const chars = characters.join('');
    const regex = new RegExp(`^[${chars}]+|[${chars}]+$`, 'g');
    return str.replace(regex, '');
}
//# sourceMappingURL=sanitize.js.map